export default "__VITE_ASSET__CB1a4ins__"